import React from 'react';

import { LabelFormattingKindEnum } from '@rtkwlf/insights';
import dayjs from 'dayjs';
import ReactDOM from 'react-dom';

import { ScaledBytes } from '@packages/components/scaled/scaled-bytes';
import { Box, Typography } from '@packages/fenrir/components';
import { Stack } from '@packages/fenrir/components/stack';
import { useFormatter } from '@packages/insights-widgets/hooks/use-formatter/use-formatter';

type SparkTooltipProps = {
  point: { x: number; y: number } | null;
  xOffset?: number;
  yOffset?: number;
};

export const SparkTooltip: React.FC<SparkTooltipProps> = ({
  point,
  xOffset = 0,
  yOffset = 0,
}) => {
  const xFormatter = useFormatter(
    { kind: LabelFormattingKindEnum.DateHourly },
    {
      default: { kind: LabelFormattingKindEnum.DateHourly },
    },
  );
  if (!point || !dayjs(point?.x).isValid) return null;

  const interval = xFormatter(dayjs(point?.x).toISOString());

  const tooltipContent = (
    <Box
      component="div"
      sx={{
        left: xOffset,
        top: yOffset,
        position: 'absolute',
        transitionProperty: 'left',
        transitionDuration: '200ms',
        boxShadow: 'rgba(0, 0, 0, 0.2) 1px 2px 10px',
        borderRadius: '4px',
      }}
      data-testid="spark-tooltip"
      padding={(theme) => theme.spacing(2)}
      bgcolor={(theme) => theme.palette.widget.widgetBackground}
    >
      <Typography variant="body2">{interval}</Typography>
      <Stack
        direction="row"
        sx={{
          marginTop: '4px',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            marginRight: '4px',
            borderRadius: '10px',
            width: '10px',
            height: '10px',
            backgroundColor: '#015F94',
          }}
        ></Typography>
        <Typography
          component="div"
          variant="subtitle2"
          sx={{
            width: 'auto',
            marginLeft: 'auto',
            fontWeight: 900,
            display: 'flex',
          }}
        >
          <ScaledBytes bytes={point.y} decimals={1} />
        </Typography>
      </Stack>
    </Box>
  );

  return ReactDOM.createPortal(tooltipContent, document.body);
};

export default SparkTooltip;
